var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "cargo-form",
      attrs: {
        model: _vm.model,
        rules: _vm.rules,
        inline: _vm.inline,
        "label-position": _vm.labelPosition,
        "label-width": "80px",
        "label-suffix": _vm.labelSuffix,
        "hide-required-asterisk": _vm.hideRequiredAsterisk,
        "show-message": _vm.showMessage,
        "inline-message": _vm.inlineMessage,
        "status-icon": _vm.statusIcon,
        disabled: _vm.disabled
      }
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        _vm._l(_vm.formItems, function(item) {
          return _c(
            "el-col",
            { key: item.field, attrs: { span: item.span } },
            [
              _c(
                "el-form-item",
                {
                  class: item.label ? "" : "label-none",
                  attrs: {
                    prop: item.field,
                    required: item.required,
                    rules: item.rules
                  }
                },
                [
                  item.label
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            slot: "label",
                            placement: "top",
                            disabled: _vm.getLength(item.label) < 12,
                            effect: "dark",
                            content: item.label,
                            size: "mini"
                          },
                          slot: "label"
                        },
                        [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  flex: "1",
                                  overflow: "hidden",
                                  "white-space": "nowrap",
                                  "text-overflow": "ellipsis"
                                }
                              },
                              [_vm._v(_vm._s(item.label))]
                            ),
                            _vm.labelSuffix
                              ? _c("span", [_vm._v(_vm._s(_vm.labelSuffix))])
                              : _vm._e()
                          ])
                        ]
                      )
                    : _vm._e(),
                  item.type === "el-radio-group"
                    ? _c(
                        "el-radio-group",
                        {
                          on: { change: item.change },
                          model: {
                            value: _vm.model[item.field],
                            callback: function($$v) {
                              _vm.$set(_vm.model, item.field, $$v)
                            },
                            expression: "model[item.field]"
                          }
                        },
                        _vm._l(item.options, function(option) {
                          return _c(
                            "el-radio",
                            {
                              key: option.value,
                              attrs: { label: option.value }
                            },
                            [_vm._v(_vm._s(option.label))]
                          )
                        }),
                        1
                      )
                    : item.type === "cargo-advance-select"
                    ? _c(
                        "cargo-advance-select",
                        _vm._b(
                          {
                            attrs: { "default-value": _vm.model[item.field] },
                            on: { parentCallBack: item.change }
                          },
                          "cargo-advance-select",
                          item.props,
                          false
                        )
                      )
                    : _c(
                        item.type,
                        _vm._b(
                          {
                            tag: "Component",
                            staticStyle: { width: "100%" },
                            on: { change: item.change },
                            model: {
                              value: _vm.model[item.field],
                              callback: function($$v) {
                                _vm.$set(_vm.model, item.field, $$v)
                              },
                              expression: "model[item.field]"
                            }
                          },
                          "Component",
                          item.props,
                          false
                        )
                      )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }